import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownFilterPanelComponent } from '@app/shared/components/dropdown-filter-panel/dropdown-filter-panel.component';
import { InitialPipe } from '@app/shared/pipes/initial.pipe';
import { MeetingAuditUser, AuditRegistrantInfo, AuditAttendeeInfo } from 'lfx-pcc';
import { AvatarModule } from 'primeng/avatar';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { onImageError } from '@app/shared/utils/helper';

@Component({
  selector: 'lfx-meeting-audit-filters-panel',
  standalone: true,
  imports: [FormsModule, MultiSelectModule, AvatarModule, DatePickerModule, InitialPipe, DropdownFilterPanelComponent],
  templateUrl: './meeting-audit-filters-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingAuditFiltersPanelComponent {
  // Filter values (two-way bound)
  public dateFrom = model<Date | null>(null);
  public dateTo = model<Date | null>(null);
  public selectedAttributes = model<{ name: string; displayName: string }[]>([]);
  public selectedUsers = model<(MeetingAuditUser & { displayName?: string })[]>([]);
  public selectedActions = model<string[]>([]);
  public selectedResources = model<string[]>([]);
  public selectedRegistrants = model<(AuditRegistrantInfo & { displayName?: string })[]>([]);
  public selectedAttendees = model<(AuditAttendeeInfo & { displayName?: string })[]>([]);

  // Filter options (read-only from parent)
  public attributeOptions = input<{ name: string; displayName: string }[]>([]);
  public userOptions = input<(MeetingAuditUser & { displayName?: string })[]>([]);
  public actionOptions = input<string[]>([]);
  public resourceOptions = input<string[]>([]);
  public registrantOptions = input<(AuditRegistrantInfo & { displayName?: string })[]>([]);
  public attendeeOptions = input<(AuditAttendeeInfo & { displayName?: string })[]>([]);

  public activeFilterCount = input<number>(0);

  public readonly filtersCleared = output<void>();

  public readonly onImageError = onImageError;

  public clearFilters(): void {
    this.dateFrom.set(null);
    this.dateTo.set(null);
    this.selectedAttributes.set([]);
    this.selectedUsers.set([]);
    this.selectedActions.set([]);
    this.selectedResources.set([]);
    this.selectedRegistrants.set([]);
    this.selectedAttendees.set([]);
    this.filtersCleared.emit();
  }
}
